import { Button } from "@mui/material";
import React, { useContext, useState } from "react";
import globalContext from '../../context/context'
import { CssTextField } from "../../utils/CssTextField";
import { useTranslation } from "react-i18next";

const defaultValues = {
    username: '',
    pass: '',
    pass2: '',
    firstName: '',
    lastName: ''
}

function RegisterComponent() {

    const { t } = useTranslation();
    const { register, setSnack } = useContext(globalContext);

    const [values, setValues] = useState(defaultValues);

    const handleRegister = () => {

        let errors = '';

        if (!values.username || !values.pass || !values.pass2) {
            errors = t("RegisterComponent.everyField")
        } else if (values.pass !== values.pass2) {
            errors = t("RegisterComponent.pwdMustMatch")
        } else if (values.pass.length < 4) {
            errors = t("RegisterComponent.pwd4Char")
        }


        if (errors) {
            setSnack({
                message: errors,
                severity: 'error',
                open: true
            })
        } else {
            register(values)
        }

    }

    const handleSetValues = (e) => {
        setValues((values) => ({ ...values, [e.target.name]: e.target.value }));
    }



    return (
        <>
            <CssTextField size="small"
                value={values.firstName}
                name="firstName"
                onChange={handleSetValues}
                sx={{ mt: 1 }} fullWidth variant="standard" label={t("RegisterComponent.firstName")} />
            <CssTextField size="small"
                value={values.lastName}
                name="lastName"
                onChange={handleSetValues}
                sx={{ mt: 1 }} fullWidth variant="standard" label={t("RegisterComponent.lastName")} />
            <CssTextField size="small"
                value={values.username}
                name="username"
                onChange={handleSetValues}
                sx={{ mt: 1 }} fullWidth variant="standard" label={t("RegisterComponent.email")} />

            <CssTextField size="small"
                value={values.pass}
                name="pass"
                onChange={handleSetValues}
                type="password"
                sx={{ mt: 1 }} fullWidth variant="standard" label={t("RegisterComponent.password")} />
            <CssTextField size="small"
                value={values.pass2}
                name="pass2"
                type="password"
                onChange={handleSetValues}
                sx={{ mt: 1 }} fullWidth variant="standard" label={t("RegisterComponent.retype")} />

            <Button variant="outlined" onClick={handleRegister}>
                {t("RegisterComponent.register")}
            </Button>
        </>
    );
}

export default RegisterComponent;
